{
  "common": {
    "loading": "載入中...",
    "redirecting": "正在跳轉至登入頁面...",
    "completingSignIn": "正在完成登入...",
    "authError": "驗證錯誤",
    "save": "儲存",
    "cancel": "取消",
    "delete": "刪除",
    "create": "建立",
    "update": "更新",
    "edit": "編輯",
    "search": "搜尋",
    "confirm": "確認",
    "saving": "儲存中...",
    "deleting": "刪除中...",
    "retry": "重試",
    "noResults": "找不到結果。",
    "signOut": "登出",
    "close": "關閉",
    "you": "你",
    "sending": "傳送中...",
    "yes": "是",
    "no": "否"
  },
  "errorBoundary": {
    "title": "發生錯誤",
    "description": "發生未預期的錯誤。你可以重試或返回儀表板。",
    "reload": "重新載入",
    "backToDashboard": "返回儀表板"
  },
  "remarks": {
    "title": "備註",
    "menuLabel": "備註 ({{count}})",
    "empty": "暫時未有備註。",
    "addPlaceholder": "為團隊新增一則內部備註…",
    "addAction": "新增備註",
    "editAction": "編輯備註",
    "deleteAction": "刪除備註",
    "deleteConfirm": "確定刪除此備註？此操作無法復原。",
    "unknownCreator": "未知用戶",
    "tooltipOpen": "查看備註",
    "select": "選取",
    "selectedCount": "已選取 {{count}} 則",
    "bulkDeleteTitle": "刪除備註",
    "bulkDeleteConfirm": "確定刪除 {{count}} 則備註？此操作無法復原。",
    "errors": {
      "bodyRequired": "備註內容不能為空。",
      "bodyTooLong": "備註過長（上限 4000 字）。"
    }
  },
  "nav": {
    "chat": "對話",
    "contacts": "聯絡人",
    "members": "用戶管理",
    "settings": "設定",
    "aiFaq": "AI 常見問題",
    "templates": "訊息範本",
    "whatsappTemplates": "WhatsApp 範本",
    "quickReplyTemplates": "快速回覆範本",
    "autoReply": "自動回覆",
    "connectEasyCart": "立即接入 EasyCart",
    "connectWhatsApp": "連接新 WhatsApp",
    "integrations": "整合管理",
    "developer": "開發者平台",
    "contactTags": "聯絡人標籤"
  },
  "onboarding": {
    "welcomeTitle": "歡迎使用 LetChat！",
    "welcomeDescription": "你目前沒有任何 WhatsApp 設定檔。請聯絡管理員取得建立配額，然後連結你的 WhatsApp 商業帳號。"
  },
  "contacts": {
    "title": "聯絡人",
    "addContact": "新增聯絡人",
    "searchPlaceholder": "搜尋聯絡人...",
    "name": "名稱",
    "phone": "電話",
    "whatsappId": "WhatsApp ID",
    "messages": "訊息",
    "created": "建立日期",
    "actions": "操作",
    "openChat": "開啟對話",
    "newContact": "新聯絡人",
    "editContact": "編輯聯絡人",
    "deleteContact": "刪除聯絡人",
    "deleteConfirm": "確定要刪除 <strong>{{name}}</strong> 嗎？此操作無法復原。所有相關訊息也會一併移除。",
    "contactCreated": "聯絡人已建立。",
    "contactUpdated": "聯絡人已更新。",
    "contactDeleted": "聯絡人已刪除。",
    "operationFailed": "操作失敗，請重試。",
    "deleteContactFailed": "刪除聯絡人失敗。",
    "phoneHelp": "含國碼的電話號碼",
    "waIdHelp": "WhatsApp ID（不含 + 號前綴）",
    "assignedTo": "指派給",
    "assignTo": "指派給",
    "assignContact": "指派聯絡人",
    "assignSuccess": "聯絡人指派已更新。",
    "searchMembers": "搜尋成員...",
    "selectedCount_one": "已選擇 {{count}} 項",
    "selectedCount_other": "已選擇 {{count}} 項",
    "bulkAssign": "指派",
    "bulkAssignSuccess": "已指派 {{count}} 個聯絡人。",
    "bulkDelete": "刪除已選",
    "bulkDeleteConfirm": "確定要刪除 {{count}} 個聯絡人嗎？此操作無法復原。",
    "bulkDeleteSuccess": "已刪除 {{count}} 個聯絡人。",
    "import": "匯入",
    "importContacts": "匯入聯絡人",
    "downloadTemplate": "下載範本",
    "importDragDrop": "拖放檔案至此處，或點擊瀏覽",
    "importFormats": "支援格式：XLSX、CSV（每個檔案最大 10MB）",
    "importStart": "開始匯入",
    "importInProgress": "匯入中...",
    "importProcessing": "正在處理匯入...",
    "importResult": "新增 {{created}} 個，更新 {{updated}} 個，跳過 {{skipped}} 個。",
    "importRowError": "第 {{row}} 行：{{error}}",
    "hidePhoneToggle": "對客服及唯讀成員隱藏電話",
    "hidePhoneToggleHelp": "啟用後，客服 (Agent) 及唯讀 (Read-Only) 角色的成員將無法在列表、編輯視窗或搜尋中看到聯絡人電話號碼。",
    "searchPlaceholderNameOnly": "以姓名搜尋..."
  },
  "chat": {
    "selectContact": "選擇聯絡人以開始對話",
    "selectContactHint": "從左側列表中選擇",
    "unknownContact": "未認識的聯絡人",
    "unknownBadge": "未認識",
    "createContact": "建立聯絡人",
    "createContactTitle": "建立聯絡人",
    "filterAll": "全部",
    "filterUnknown": "未認識",
    "noUnknownContacts": "沒有未認識的聯絡人。",
    "noMessages": "尚無訊息。發送訊息以開始對話。",
    "noContacts": "找不到聯絡人。",
    "typeMessage": "輸入訊息...",
    "searchContacts": "搜尋聯絡人...",
    "sendTemplate": "發送範本",
    "templatePickerTitle": "訊息範本",
    "templatePickerDesc": "選擇已批准的範本以開始對話",
    "noTemplates": "沒有已批准的範本。請在 Meta Business Suite 中建立範本。",
    "templateSent": "範本訊息已發送。",
    "loadingTemplates": "正在載入範本...",
    "windowClosed": "24 小時對話窗口已過期。請發送範本訊息以重新聯繫。",
    "windowClosedNoMessages": "發送範本訊息以開始與此聯絡人的對話。",
    "messageFailed": "訊息發送失敗",
    "templateParamTitle": "填寫範本參數",
    "templatePreview": "預覽",
    "templateParam": "參數 {{index}}",
    "templateParamRequired": "所有參數均為必填",
    "sendTemplateBtn": "發送範本",
    "templateNoParams": "此範本不需要填寫參數。",
    "quickReplyPickerDesc": "選擇快速回覆範本...",
    "noQuickReplies": "沒有快速回覆範本。",
    "slashHint": "快速回覆",
    "slashNoMatches": "沒有相符的快速回覆",
    "slashClose": "關閉快速回覆",
    "revokedMessage": "此訊息已被刪除",
    "revokedTooltip": "已被聯絡人刪除",
    "edited": "已編輯",
    "editHistory": "編輯紀錄",
    "editHistoryVersion": "版本 {{index}}",
    "editHistoryCurrent": "目前",
    "download": "下載",
    "openInMaps": "在地圖中開啟",
    "contactCard": "聯絡人",
    "voiceMessage": "語音訊息",
    "stickerMessage": "貼圖",
    "document": "文件",
    "mediaLoadError": "無法載入媒體",
    "locationMessage": "位置",
    "videoMessage": "影片",
    "imageMessage": "圖片",
    "interactiveMessage": "互動訊息",
    "templateMessage": "範本訊息",
    "attachFile": "附加檔案",
    "recordVoice": "錄製語音訊息",
    "recording": "錄音中...",
    "replyTo": "回覆",
    "replyingTo": "回覆",
    "react": "回應",
    "cancelAttachment": "取消",
    "caption": "新增說明...",
    "uploadFailed": "上傳失敗",
    "unsupportedFileType": "不支援的檔案類型",
    "fileTooLarge": "檔案太大（最大 {{max}}MB）",
    "sendingStatus": "傳送中...",
    "removeReaction": "移除回應",
    "stopRecording": "停止並傳送",
    "cancelRecording": "取消錄音"
  },
  "settings": {
    "title": "設定",
    "membersTab": "成員",
    "integrationsTab": "整合",
    "teamMembers": "團隊成員",
    "teamMembersDesc": "管理誰可以存取此 WhatsApp 設定檔",
    "inviteMember": "邀請成員",
    "inviteTitle": "邀請團隊成員",
    "emailAddress": "電郵地址",
    "sendInvite": "發送邀請",
    "inviteSent": "邀請已發送至 {{email}}",
    "easyCartTitle": "EasyCart 整合",
    "easyCartDesc": "連結你的 EasyCart 商店以進行零同步訂單查詢",
    "easyCartApiUrl": "EasyCart API 網址",
    "apiToken": "API 權杖",
    "saveIntegration": "儲存整合",
    "savedSuccess": "儲存成功！",
    "whatsappProfileTitle": "WhatsApp 設定檔資訊",
    "whatsappProfileDesc": "連結後，設定檔詳情和電話號碼資訊將顯示於此。請透過 Meta Business Suite 管理你的 WhatsApp 商業帳號設定。"
  },
  "members": {
    "title": "用戶管理",
    "inviteMember": "邀請成員",
    "teamMembers": "團隊成員",
    "teamMembersDesc": "管理誰可以存取此 WhatsApp 設定檔",
    "pendingInvitations": "待接受的邀請",
    "invitedBy": "邀請人",
    "inviteTitle": "邀請團隊成員",
    "emailAddress": "電郵地址",
    "role": "角色",
    "roleOwner": "擁有者",
    "roleAdmin": "管理員",
    "roleAgent": "客服人員",
    "roleReadOnly": "唯讀",
    "sendInvite": "發送邀請",
    "sending": "發送中...",
    "inviteSent": "邀請已發送至 {{email}}。",
    "inviteSentNewUser": "帳號已建立，邀請已發送至 {{email}}。",
    "removeMember": "移除成員",
    "removeConfirm": "確定要將 {{name}} 從此帳號移除嗎？對方將立即失去存取權限。",
    "memberRemoved": "成員已移除。",
    "transferOwnership": "轉移擁有權",
    "transferConfirm": "確定要將擁有權轉移給 {{name}} 嗎？你將變為管理員角色。",
    "ownershipTransferred": "擁有權已轉移。",
    "cancelInvitation": "取消邀請",
    "invitationCancelled": "邀請已取消。",
    "resendInvitation": "重新發送邀請",
    "invitationResent": "邀請已重新發送。",
    "changeRole": "更改角色",
    "roleChanged": "角色已更新。",
    "cannotRemoveOwner": "無法移除擁有者。",
    "cannotRemoveSelf": "你無法移除自己。",
    "operationFailed": "操作失敗，請重試。",
    "nickname": "暱稱",
    "editNickname": "編輯暱稱",
    "nicknameSaved": "暱稱已更新",
    "nicknamePlaceholder": "可選"
  },
  "invitation": {
    "title": "團隊邀請",
    "accept": "接受邀請",
    "decline": "拒絕",
    "expired": "此邀請已過期。",
    "alreadyAccepted": "此邀請已被接受。",
    "notFound": "找不到邀請。",
    "youveBeenInvited": "你已被邀請加入 LetChat 上的團隊。",
    "invitedBy": "邀請人",
    "asRole": "角色",
    "account": "帳號",
    "acceptSuccess": "邀請已接受！正在跳轉...",
    "goToDashboard": "前往控制面板"
  },
  "tenantSelection": {
    "title": "選擇你的 WhatsApp 帳號",
    "subtitle": "選擇一個工作空間以開始你的 WhatsApp 編輯工作。",
    "accessAccount": "進入帳號",
    "connectNew": "連接新 WhatsApp 帳號",
    "connectNewDesc": "新增一個 WhatsApp 商業設定檔，擴展你的業務範圍。",
    "switchAccount": "切換帳號",
    "wabaNotLinked": "尚未連結 WABA",
    "noQuotaTooltip": "沒有可用配額。請先增加建立配額，才能連接新帳號。",
    "copyright": "\u00a9 2024 LetChat CRM. 版權所有。",
    "privacy": "私隱政策",
    "terms": "服務條款",
    "support": "支援"
  },
  "whatsappSignup": {
    "dialogTitle": "連接新 WhatsApp 帳號",
    "dialogDescription": "透過 Meta 的安全嵌入式註冊連結你的 WhatsApp 商業帳號。你將在彈出視窗中完成設定流程。",
    "stepLoadingSdk": "正在載入 Meta SDK...",
    "stepWaitingMeta": "請在 Meta 彈出視窗中完成設定...",
    "stepCollecting": "正在與 Meta 同步帳號資料...",
    "stepExchanging": "正在建立你的 WhatsApp 設定檔...",
    "successTitle": "WhatsApp 帳號已連接！",
    "successDescription": "你的 WhatsApp 設定檔「{{name}}」已成功建立。即將跳轉至控制面板。",
    "errorTitle": "連接失敗",
    "close": "關閉",
    "goToDashboard": "前往控制面板"
  },
  "aiFaq": {
    "title": "AI 常見問題配置",
    "description": "上傳常見問題文件以訓練 AI 助手。系統使用 RAG（檢索增強生成）技術，根據上傳內容回答客戶問題。",
    "notEnabled": "此 WhatsApp 設定檔尚未啟用 AI 常見問題功能。請聯絡管理員啟用此附加功能。",
    "knowledgeBase": "知識庫",
    "knowledgeBaseDesc": "上傳 PDF 或 TXT 檔案以建立 AI 的知識庫",
    "dragDrop": "拖放檔案至此處，或點擊瀏覽",
    "supportedFormats": "支援格式：PDF、TXT（每個檔案最大 10MB）",
    "browseFiles": "瀏覽檔案",
    "generatingEmbeddings": "正在生成語意向量...",
    "indexed": "已索引（{{chunks}} 個區塊）",
    "testSandbox": "測試沙盒",
    "testSandboxDesc": "使用範例問題測試 AI 回覆品質",
    "askPlaceholder": "輸入測試問題...",
    "ask": "提問",
    "viewContexts": "查看檢索到的上下文（{{count}} 個區塊）",
    "chunk": "區塊 {{index}}",
    "score": "分數：{{score}}"
  },
  "templates": {
    "title": "訊息範本",
    "createTemplate": "建立範本",
    "searchPlaceholder": "搜尋範本...",
    "name": "範本名稱",
    "category": "類別",
    "language": "語言",
    "status": "狀態",
    "qualityScore": "品質",
    "actions": "操作",
    "viewDetails": "查看詳情",
    "deleteTemplate": "刪除範本",
    "deleteConfirm": "確定要刪除範本 <strong>{{name}}</strong> 嗎？此操作無法復原。",
    "editTemplate": "編輯範本",
    "editTitle": "編輯訊息範本",
    "templateCreated": "範本已提交審核。",
    "templateUpdated": "範本已更新並重新提交審核。",
    "templateDeleted": "範本已刪除。",
    "operationFailed": "操作失敗，請重試。",
    "deleteFailed": "刪除範本失敗。",
    "noTemplates": "找不到範本。建立你的第一個範本以開始使用。",
    "statusAll": "全部",
    "statusApproved": "已批准",
    "statusPending": "審核中",
    "statusRejected": "已拒絕",
    "statusPaused": "已暫停",
    "statusDisabled": "已停用",
    "categoryMarketing": "行銷",
    "categoryUtility": "公用程式",
    "categoryAuthentication": "驗證",
    "createTitle": "建立訊息範本",
    "basicInfo": "基本資訊",
    "templateNameHelp": "僅限小寫英文字母、數字及底線",
    "systemBadge": "系統",
    "systemPrefixReserved": "「system_」前綴為系統範本保留，請使用其他名稱",
    "content": "內容",
    "variableType": "變數類型",
    "variableTypeName": "名稱",
    "variableTypeNumber": "數字",
    "variableTypeHelp": "變數是可在範本中動態插入特定資訊或資料的預留位置，你可以插入名稱或數字作為參數。",
    "variableTypeNameExample": "範例：{{order_id}}, {{customer_name}}",
    "variableTypeNumberExample": "範例：{{1}}, {{2}}",
    "mediaSample": "影音素材範例",
    "mediaNone": "無",
    "mediaImage": "圖像",
    "mediaVideo": "影片",
    "mediaDocument": "文件",
    "header": "標題",
    "headerHelp": "選填。為你的訊息新增一行簡短文字。",
    "body": "內文",
    "bodyRequired": "內文為必填項目",
    "footer": "頁尾",
    "footerHelp": "選填。請以English在訊息底部新增一行簡短文字。",
    "addVariable": "新增變數",
    "variableNamePrompt": "輸入變數名稱（小寫字母、底線及數字）：",
    "buttons": "按鈕",
    "buttonsHelp": "建立可讓顧客回覆訊息或採取動作的按鈕。你最多可新增 10 個按鈕。如果新增超過 3 個按鈕，這些按鈕將以清單形式顯示。",
    "addButton": "新增按鈕",
    "buttonCustom": "自訂",
    "buttonVisitWebsite": "瀏覽網站",
    "buttonCallPhone": "撥打電話號碼",
    "buttonText": "按鈕文字",
    "urlType": "網址類型",
    "urlTypeStatic": "靜態",
    "urlTypeDynamic": "動態",
    "websiteUrl": "網站網址",
    "countryRegion": "國家 / 地區",
    "phoneNumber": "電話號碼",
    "callToAction": "行動呼籲",
    "quickReply": "快速回覆",
    "duplicateButtonText": "你無法為多個按鈕輸入相同的文字內容。",
    "phoneRequired": "你必須輸入手機號碼，請新增有效的手機號碼。",
    "messageValidity": "訊息有效期限",
    "messageValidityHelp": "你可以自訂必須傳送實用訊息的有效期限，逾期後訊息即失效。如果訊息未在這個期限內傳送，顧客就不會看到訊息，我們也不會向你收費。",
    "customValidity": "自訂訊息的有效期限",
    "validitySeconds": "有效期限（秒）",
    "submit": "提交範本",
    "submitting": "提交中...",
    "uploadFile": "上傳檔案",
    "uploadDragDrop": "拖放檔案至此處，或點擊瀏覽",
    "uploading": "上傳中...",
    "uploadFailed": "檔案上傳失敗。",
    "exampleValues": "範例值",
    "exampleValuesHelp": "為每個變數提供範例值。這些值將作為範本審核的一部分進行審查。",
    "errorNamedFormat": "此範本內含格式錯誤的變數參數。變數參數必須由小寫字母、底線和數字組成，並在前後加上兩組大括號（例如{{customer_name}}, {{order_id}}）。變數不得位於範本的開頭或結尾。",
    "errorPositionalFormat": "此範本內含格式錯誤的變數參數。變數參數必須是整數，並在前後加上大括號（例如：{{1}}, {{2}}）。變數不得位於範本的開頭或結尾。",
    "errorTooManyVariables": "以範本長度而言，此範本的變數過多。請減少變數數量或增加訊息長度。變數不得位於範本的開頭或結尾。",
    "errorVariableStartEnd": "變數不得位於範本的開頭或結尾。",
    "errorNamedDuplicate": "不允許重複的變數名稱。",
    "errorPositionalSequence": "位置變數必須按順序排列（例如：{{1}}, {{2}}, {{3}}）。",
    "errorHeaderEmoji": "標題不可包含 Emoji，WhatsApp 會拒絕此範本。",
    "errorFooterEmoji": "頁尾不可包含 Emoji，WhatsApp 會拒絕此範本。",
    "maxButtons": "此類型按鈕最多允許 {{max}} 個。"
  },
  "quickReply": {
    "title": "快速回覆範本",
    "createTemplate": "建立範本",
    "createTitle": "建立快速回覆範本",
    "editTitle": "編輯快速回覆範本",
    "searchPlaceholder": "搜尋快速回覆...",
    "name": "範本名稱",
    "nameHelp": "為此快速回覆輸入描述性名稱",
    "command": "指令",
    "commandHelp": "小寫英文字母、數字、- 和 _。在對話中輸入 / 再加此指令即可選取此回覆。",
    "commandInvalid": "只能使用小寫英文字母、數字、- 和 _。",
    "messageType": "訊息類型",
    "typeText": "純文字",
    "typeInteractive": "互動訊息",
    "interactiveType": "互動類型",
    "replyButtons": "快速回覆按鈕",
    "listMessage": "列表訊息",
    "headerSection": "標題",
    "header": "標題文字",
    "headerHelp": "選填。訊息頂部顯示的簡短標題（最多60字元）。",
    "body": "內文",
    "footer": "頁尾",
    "footerHelp": "選填。訊息底部的一行簡短文字（最多60字元）。",
    "mediaType": "標題媒體類型",
    "mediaTypeNone": "無（僅文字）",
    "mediaTypeImage": "圖片",
    "mediaTypeVideo": "影片",
    "mediaTypeDocument": "文件",
    "mediaTypeHelp": "選擇標題的媒體類型，或留空使用文字標題。",
    "uploadDragDrop": "拖放檔案至此處，或點擊瀏覽",
    "uploadFailed": "檔案上傳失敗，請重試。",
    "mediaUploaded": "媒體已上傳",
    "buttonTitle": "按鈕標籤",
    "addButton": "新增按鈕",
    "maxButtons": "最多允許 3 個快速回覆按鈕。",
    "listButtonText": "選單按鈕標籤",
    "listButtonTextHelp": "開啟列表選單的按鈕標籤（最多20字元）。",
    "sections": "區段",
    "addSection": "新增區段",
    "sectionTitle": "區段標題",
    "rows": "選項",
    "addRow": "新增選項",
    "rowTitle": "選項標題",
    "rowDescription": "描述（選填）",
    "previewTitle": "預覽互動訊息",
    "confirmSend": "發送",
    "listSectionsPreview": "列表區段：",
    "created": "建立日期",
    "viewDetails": "查看詳情",
    "deleteTemplate": "刪除範本",
    "deleteConfirm": "確定要刪除 <strong>{{name}}</strong> 嗎？此操作無法復原。",
    "templateCreated": "快速回覆範本已建立。",
    "templateUpdated": "快速回覆範本已更新。",
    "templateDeleted": "快速回覆範本已刪除。",
    "operationFailed": "操作失敗，請重試。",
    "noTemplates": "找不到快速回覆範本。建立你的第一個範本以開始使用。",
    "selectedCount_one": "已選擇 {{count}} 項",
    "selectedCount_other": "已選擇 {{count}} 項",
    "bulkDelete": "刪除已選",
    "bulkDeleteConfirm": "確定要刪除 {{count}} 個快速回覆範本嗎？此操作無法復原。",
    "bulkDeleteSuccess": "已刪除 {{count}} 個快速回覆範本。",
    "sourceSystem": "系統",
    "sourceCustom": "自訂",
    "sourceLabel": "來源",
    "systemReadOnly": "系統範本由 LetChat 管理，無法修改或刪除。",
    "systemTooltip": "由 LetChat 管理",
    "typeEshop": "EasyCart 功能",
    "typeEshopDisabled": "請先於「整合管理」連接 EasyCart 才能使用此選項。"
  },
  "autoReply": {
    "title": "自動回覆",
    "description": "設定關鍵字觸發自動回覆，建立類似 IVR 的系統。當客戶發送符合關鍵字的訊息時，系統會自動回覆。",
    "createRule": "建立自動回覆",
    "editRule": "編輯自動回覆",
    "searchPlaceholder": "搜尋自動回覆...",
    "keywords": "觸發關鍵字",
    "keywordsHelp": "新增觸發此自動回覆的關鍵字。其他範本的按鈕標題會自動建議。按 Enter 新增。",
    "keywordsPlaceholder": "輸入關鍵字後按 Enter...",
    "fromButton": "按鈕",
    "matchType": "配對方式",
    "matchContains": "包含",
    "matchExact": "完全配對",
    "matchContainsHelp": "當關鍵字出現在客戶訊息中的任何位置時觸發回覆。",
    "matchExactHelp": "只有當客戶訊息完全匹配關鍵字時才觸發回覆。",
    "enabled": "已啟用",
    "disabled": "已停用",
    "status": "狀態",
    "nextStep": "下一步",
    "nextStepHelp": "選擇當按鈕被點擊時要發送的自動回覆範本。",
    "nextStepNone": "無（流程結束）",
    "nextStepCreate": "建立新範本...",
    "noRules": "未找到自動回覆規則。建立您的第一條規則開始使用。",
    "ruleCreated": "自動回覆規則已建立。",
    "ruleUpdated": "自動回覆規則已更新。",
    "ruleDeleted": "自動回覆規則已刪除。",
    "deleteRule": "刪除自動回覆",
    "deleteConfirm": "確定要刪除 <strong>{{name}}</strong> 嗎？任何連結到此範本的鏈式規則將會失去連接。",
    "operationFailed": "操作失敗。請重試。",
    "viewList": "列表檢視",
    "viewFlow": "流程畫布",
    "addTrigger": "新增觸發器",
    "autoLayout": "自動排列",
    "fitView": "適合檢視",
    "triggerNode": "觸發器",
    "messageNode": "訊息",
    "paused": "已暫停",
    "flowSaved": "流程已儲存。",
    "flowSaveFailed": "儲存流程失敗。",
    "bulkDeleteConfirm": "確定要刪除 {{count}} 條自動回覆規則嗎？此操作無法復原。",
    "bulkDeleteSuccess": "已刪除 {{count}} 條自動回覆規則。",
    "selectedCount_one": "已選擇 {{count}} 個",
    "selectedCount_other": "已選擇 {{count}} 個",
    "deleteHasChildren": "「{{name}}」有已連結的子節點。請選擇處理方式：",
    "affectedChildren": "受影響的子節點：",
    "deleteThisOnly": "僅刪除此節點",
    "deleteThisOnlyDesc": "子節點將保留其關鍵字，成為獨立的入口點。",
    "deleteSubtree": "刪除整個子樹",
    "deleteSubtreeDesc": "刪除此節點及所有 {{count}} 個已連結的子節點。",
    "subtreeDeleted": "已刪除 {{count}} 條自動回覆規則。",
    "duplicateKeywords": "發現重複關鍵字：{{conflicts}}。每個關鍵字只能屬於一條自動回覆規則。",
    "eshopFunction": "EasyCart 功能",
    "eshopFunctionHelp": "選擇完成 Q&A 後要執行的 EasyCart 動作。",
    "eshopFunctionSelect": "功能",
    "eshopNoIntegration": "此範本使用 EasyCart 功能，但尚未連接 EasyCart。請先於「整合管理」連接，否則流程無法執行。",
    "eshopOpeningMessage": "開場訊息",
    "eshopOpeningMessageHelp": "在第一條問題之前先傳送給聯絡人。",
    "eshopParamQuestion": "提問內容",
    "eshopParamRegexReadonly": "答案格式要求",
    "eshopParamRegexReadonlyHelp": "由 EasyCart 功能決定，管理員無法修改；答案不符此格式時功能會失敗。",
    "eshopParamError": "錯誤訊息（可選）",
    "eshopParamErrorHelp": "當答案不符合正規式時顯示，之後會重新提問。",
    "eshopCancelButtonLabel": "取消按鈕文字",
    "eshopCancelButtonLabelHelp": "每條問題旁顯示的取消按鈕文字（最多 20 字元），預設為「Cancel」。"
  },
  "integration": {
    "settingsTitle": "整合管理",
    "connected": "已連接",
    "disconnected": "未連接",
    "merchantId": "商戶 ID",
    "storeName": "商店名稱",
    "connectedSince": "連接日期",
    "permissions": "權限",
    "disconnect": "斷開連接",
    "disconnectTitle": "斷開 EasyCart",
    "disconnectConfirm": "確定要斷開此 EasyCart 整合嗎？你將無法存取已連結的商店資料。",
    "noIntegration": "未連接任何整合。請使用側邊欄按鈕連接你的 EasyCart 商店。",
    "connecting": "連接中...",
    "connectSuccess": "EasyCart 連接成功！",
    "connectFailed": "EasyCart 連接失敗。",
    "noProfile": "找不到此用戶的 EasyCart 商戶帳號。請先建立 EasyCart 帳號。",
    "denied": "授權已被拒絕。",
    "error": "授權過程中發生錯誤。"
  },
  "integrations": {
    "eshop": {
      "records": "EasyCart 紀錄",
      "customerInfo": "客戶資料",
      "orders": "訂單紀錄",
      "bookings": "預約紀錄",
      "notFound": "找不到紀錄",
      "notConnected": "尚未連接 EasyCart",
      "fetchError": "無法取得 EasyCart 資料",
      "orderDetail": "訂單詳情",
      "customerData": "客戶資料",
      "shippingInfo": "運送資料",
      "orderItems": "訂單商品",
      "orderRemarks": "訂單備註",
      "noRemarks": "暫無備註",
      "productAmount": "商品總額",
      "transactionFee": "交易手續費",
      "notApplicable": "不適用",
      "field": {
        "name": "姓名",
        "email": "電郵",
        "phone": "電話",
        "membership": "會員等級",
        "points": "積分",
        "memberSince": "註冊日期",
        "orderNumber": "訂單編號",
        "amount": "金額",
        "status": "狀態",
        "paymentMethod": "付款方式",
        "date": "日期",
        "service": "服務",
        "dateTime": "日期時間",
        "price": "價格",
        "confirmed": "已確認",
        "paid": "已付款",
        "customer": "顧客 / 銷售點資料",
        "recipient": "收件人",
        "contactPhone": "電話",
        "contactEmail": "電郵",
        "shippingMethod": "送貨方式",
        "shippingNumber": "追蹤編號 / 取貨編號",
        "shippingFee": "已收運費",
        "deliveryAddress": "送貨地址",
        "orderDate": "訂單日期",
        "product": "商品",
        "quantity": "數量",
        "unitPrice": "單價",
        "subtotal": "小計",
        "discount": "折扣",
        "total": "訂單總額",
        "freeShipping": "免運費",
        "notShippedYet": "尚未發貨"
      },
      "orderStatus": {
        "processing": "已付款",
        "shipped": "已發貨",
        "completed": "已完成",
        "failure": "已失敗"
      },
      "paymentMethod": {
        "in-app": "應用內付款",
        "wechat-pay": "微信支付",
        "alipay": "支付寶",
        "alipayhk": "支付寶香港",
        "paypal": "PayPal",
        "card": "信用卡",
        "bbmsl": "BBMSL",
        "bank": "銀行轉賬",
        "qfpay": "QFPay",
        "CASH_PAY": "現金",
        "CREDIT_CARD_PAY": "信用卡",
        "ALI_PAY": "支付寶",
        "WECHAT_PAY": "微信支付",
        "OCTOPUS_PAY": "八達通",
        "VISA_PAY": "Visa",
        "MASTER_CARD_PAY": "Mastercard",
        "FPS_PAY": "轉數快",
        "PAYME_PAY": "PayMe"
      }
    }
  },
  "notifications": {
    "title": "通知",
    "clearAll": "清除全部",
    "noNotifications": "沒有通知",
    "markAllRead": "全部標為已讀",
    "importComplete": "聯絡人匯入完成",
    "importCompleteMsg": "新增 {{created}} 個，更新 {{updated}} 個，跳過 {{skipped}} 個。",
    "importResultTitle": "匯入結果",
    "importResultCreated": "新增：{{count}} 個聯絡人",
    "importResultUpdated": "更新：{{count}} 個聯絡人",
    "importResultSkipped": "跳過：{{count}} 行",
    "importResultErrorsTitle": "錯誤",
    "importResultErrorRow": "第 {{row}} 行：",
    "importFailed": "聯絡人匯入失敗",
    "failedMsg": "發生錯誤，請聯絡客服。",
    "templateApproved": "範本已通過審核",
    "templateApprovedMsg": "範本「{{templateName}}」({{language}}) 已通過審核，可以使用。",
    "templateRejected": "範本未通過審核",
    "templateRejectedMsg": "範本「{{templateName}}」({{language}}) 未通過審核。原因：{{reason}}",
    "templateStatusChanged": "範本狀態變更",
    "templateStatusChangedMsg": "範本「{{templateName}}」({{language}}) 狀態已變更為 {{status}}。",
    "templateCategoryWarning": "範本類別即將變更",
    "templateCategoryWarningMsg": "範本「{{templateName}}」({{language}}) 將於 24 小時內從 {{newCategory}} 重新分類為 {{correctCategory}}。",
    "templateCategoryUpdated": "範本類別已變更",
    "templateCategoryUpdatedMsg": "範本「{{templateName}}」({{language}}) 類別已從 {{previousCategory}} 變更為 {{newCategory}}。",
    "contactAssigned": "已被指派聯絡人",
    "contactAssignedMsg": "{{actorName}} 將 {{contactName}} 指派給您。",
    "timeAgo": {
      "justNow": "剛剛",
      "minutesAgo": "{{count}} 分鐘前",
      "hoursAgo": "{{count}} 小時前",
      "daysAgo": "{{count}} 天前"
    }
  },
  "mobilePairing": {
    "menuEntry": "手機裝置",
    "title": "配對手機裝置",
    "subtitle": "產生 QR Code 並用 LetChat 手機應用程式掃描以登入。",
    "prompt": "產生新的 QR Code 來配對裝置。",
    "generate": "產生 QR Code",
    "scanInstructions": "開啟 LetChat 手機應用程式並掃描此 QR Code。5 分鐘後失效，僅能使用一次。",
    "paired": "配對成功",
    "expired": "QR Code 已過期，請重新產生。",
    "cancel": "取消",
    "pairedDevices": "已配對裝置",
    "noDevices": "尚未配對任何裝置。",
    "revoke": "撤銷",
    "revoked": "已撤銷",
    "manualFallback": "若無法掃描，可在手機端輸入以下配對代碼：",
    "copy": "複製",
    "copied": "已複製",
    "lastUsedAt": "上次使用",
    "pairedAt": "配對時間",
    "unknownPlatform": "未知裝置"
  },
  "apiClients": {
    "menuEntry": "API 客戶端",
    "title": "API 客戶端",
    "subtitle": "供第三方整合（Zapier、n8n、自家後端）使用的 API 憑證。",
    "lede": "為 Zapier、n8n 或你自己的後端發出 API 憑證，代表你存取 LetChat 資料。每個客戶端使用短效 access token（30 分鐘），由長效客戶端密鑰交換取得。",
    "developerBadge": "開發者 · API 平台",
    "createButton": "新增客戶端",
    "searchPlaceholder": "依名稱或描述搜尋…",
    "showRevoked": "顯示已撤銷",
    "noMatches": "沒有符合「{{term}}」的客戶端。",
    "revoked": "已撤銷",
    "revoke": "撤銷",
    "created": "建立時間",
    "lastUsed": "最近使用",
    "ipRestricted": "IP 白名單",
    "anyIp": "任何 IP",
    "activeUsed": "啟用中 · {{ago}}前使用",
    "workspacesPlural": "{{count}} 個 workspace",
    "scopesPlural_one": "{{count}} 個 scope",
    "scopesPlural_other": "{{count}} 個 scope",
    "ipAllowlistCount_one": "{{count}} 個 IP 白名單",
    "ipAllowlistCount_other": "{{count}} 個 IP 白名單",
    "stats": {
      "activeClients": "啟用中的客戶端",
      "ipRestricted": "已限制 IP 的客戶端",
      "calls7d": "API 呼叫 — 過去 7 日",
      "rateLimit": "速率限制",
      "perClient": "每個客戶端",
      "comingSoon": "即將推出"
    },
    "empty": {
      "archivalLabel": "§I · 設定",
      "title": "讓你的系統連接 LetChat",
      "body": "建立一個 API 客戶端，讓 Zapier、n8n 或自家後端代表你讀取聯絡人、發送訊息及管理範本。每個客戶端使用短效 30 分鐘 access token，由長效客戶端密鑰交換取得。",
      "createFirst": "建立你的第一個客戶端",
      "benefits": {
        "scoped": {
          "title": "限定 workspace",
          "body": "可選擇每個客戶端能存取哪些 workspace 與哪些功能 — 與你的用戶權限分開設定，但會在每次請求時驗證。"
        },
        "shortLived": {
          "title": "短效 token",
          "body": "Token 30 分鐘後自動失效，撤銷後即時生效。"
        },
        "audit": {
          "title": "完整審計記錄",
          "body": "所有 API 請求均會紀錄至日誌中並保留 7 日。"
        }
      }
    },
    "scopeGroups": {
      "contacts": { "label": "聯絡人", "description": "客戶資料、標籤、備註" },
      "messages": { "label": "訊息", "description": "收發訊息串流" },
      "remarks": { "label": "備註", "description": "附在聯絡人上的內部備註" },
      "templates": { "label": "範本", "description": "WhatsApp 訊息範本" },
      "quickReplies": { "label": "快速回覆", "description": "客服快捷片段" },
      "autoReplies": { "label": "自動回覆", "description": "規則式自動化" },
      "aiFaq": { "label": "AI FAQ", "description": "知識庫與 AI 回答" },
      "members": { "label": "成員", "description": "Workspace 席位管理" },
      "settings": { "label": "設定", "description": "Workspace 設定" },
      "tags": { "label": "聯絡人標籤", "description": "管理及套用聯絡人標籤" }
    },
    "scopeLabels": {
      "read": "讀取",
      "write": "建立 / 更新",
      "delete": "刪除",
      "assign": "指派",
      "send": "傳送",
      "apply": "套用"
    },
    "create": {
      "title": "建立 API 客戶端",
      "newClient": "新客戶端",
      "issueCredentials": "發出憑證",
      "shortLivedNotice": "Access token 有效期為 30 分鐘。",
      "stepCounter": "第 {{current}} 步，共 {{total}} 步",
      "back": "返回",
      "continue": "繼續",
      "issue": "發出憑證",
      "creating": "建立中…",
      "genericError": "無法建立客戶端，請重試。",
      "nameLabel": "客戶端名稱",
      "namePlaceholder": "例如 Zapier — production",
      "nameHelper": "{{count}}/60 字 · 將顯示於日誌與客戶端列表",
      "descriptionLabel": "說明",
      "descriptionPlaceholder": "此客戶端的用途、由誰維護、運行於何處。",
      "namingTipTitle": "命名小貼士",
      "namingTipBody": "在名稱前加上工具與環境，例如 n8n — staging、Internal BI。",
      "noTenants": "你尚未獲得任何 workspace 的存取權。",
      "noCurrentWorkspace": "請先選擇一個 workspace。",
      "noScopesAvailable": "你在此 workspace 嘅角色未獲得任何可授予嘅 API scope。請聯絡管理員提升你嘅角色，或由管理員代為發出此客戶端。",
      "tenantRoleLine": "{{permissions}} 個權限",
      "selectTenantsFirst": "請先選擇至少一個 workspace。",
      "scopesIntro": "只顯示你嘅角色喺現時 workspace 可以授予嘅 scope。",
      "scopesIntro_one": "顯示適用於所選 {{count}} 個 workspace 的 scope。",
      "scopesIntro_other": "顯示適用於所有所選 {{count}} 個 workspace 的 scope。",
      "selectAllAvailable": "全選可用",
      "scopeLockedHint": "你的角色在所有所選 workspace 並未獲得對應權限",
      "ipModeAny": {
        "title": "任何 IP",
        "body": "允許任何來源的請求。若你的整合運行於 Zapier / Serverless 平台（IP 不固定），請使用此選項。"
      },
      "ipModeAllowlist": {
        "title": "IP 白名單",
        "body": "只接受所列 IP 的請求。建議用於自架後端。"
      },
      "recommended": "推薦",
      "ipAllowlistLabel": "允許的 IP / CIDR 範圍",
      "ipAllowlistHelper": "每行一個。支援 IPv4、IPv6 或 CIDR 標記。",
      "ipRejectNotice": "任何不在此清單中的 IP 之請求將會被拒絕。",
      "alwaysOnTitle": "預設防護",
      "alwaysOnBody": "系統設有 120 次 / 分鐘 API 請求次數限制，並會將所有請求紀錄至日誌中並保留 7 日。",
      "steps": {
        "details": { "label": "詳細資料", "title": "為此客戶端命名", "blurb": "請給此客戶端一個清晰的內部名稱。只有你會看到。" },
        "access": { "label": "Workspace", "title": "選擇 workspace", "blurb": "選擇此客戶端可運作於哪些 workspace。每次請求時都會重新檢查你的權限。" },
        "scopes": { "label": "權限", "title": "選擇權限", "blurb": "選擇整合最少所需的 scope。只顯示你在所有所選 workspace 均能授予的 scope。" },
        "restrict": { "label": "限制", "title": "限制存取", "blurb": "可選擇限制使用此客戶端的 IP。我們會拒絕任何其他來源的請求。" },
        "review": { "label": "確認", "title": "確認與發出", "blurb": "在發出客戶端 ID 與客戶端密鑰前最後檢查。密鑰只會顯示一次。" }
      }
    },
    "review": {
      "name": "名稱",
      "description": "說明",
      "workspace": "Workspace",
      "workspaces": "Workspace",
      "scopes": "Scope",
      "scopesWithCount": "Scope · {{count}}",
      "ipRestriction": "IP 限制",
      "anyIp": "允許任何 IP",
      "secretWarning": "客戶端密鑰將會在下一個畫面顯示一次。請複製到你的密碼管理器 — 我們無法再次顯示。"
    },
    "secretDialog": {
      "badge": "憑證已發出 — 只顯示一次",
      "title": "立即儲存你的客戶端密鑰",
      "subtitle": "一旦關閉此對話框，我們將無法再次顯示此密鑰，必須輪換才可。",
      "clientIdLabel": "客戶端 ID",
      "clientSecretLabel": "客戶端密鑰",
      "quickstart": "快速開始",
      "acknowledge": "我已將客戶端密鑰安全儲存",
      "done": "完成"
    },
    "detail": {
      "activeClient": "啟用中的客戶端",
      "tabs": {
        "overview": "概覽",
        "code": "快速開始",
        "settings": "設定"
      },
      "clientIdLabel": "客戶端 ID",
      "clientSecretLabel": "客戶端密鑰",
      "hashedAtRest": "安全儲存",
      "miniStats": {
        "calls7d": "呼叫 · 7 日",
        "errorRate": "錯誤率",
        "lastUsed": "最近使用"
      },
      "never": "從未",
      "sections": {
        "workspaces": "Workspace",
        "scopes": "Scope",
        "ipAllowlist": "IP 白名單"
      },
      "granted_one": "{{count}} 個已授予",
      "granted_other": "{{count}} 個已授予",
      "ranges_one": "{{count}} 個範圍",
      "ranges_other": "{{count}} 個範圍",
      "unrestricted": "不限",
      "anyIpWarning": "任何 IP 均可使用此客戶端。若你的後端運行於固定網絡，建議設定白名單。",
      "rateLimit": "每分鐘 120 次請求 · Access token 30 分鐘失效",
      "quickstart": {
        "exchangeTitle": "用密鑰換取 access token",
        "exchangeBody": "長效客戶端密鑰永不在 API 呼叫中出現。Access token 過期時請重新交換。",
        "callTitle": "用 access token 呼叫 API",
        "callBody": "此客戶端已綁定到一個 workspace，毋須在請求中加入額外 header。",
        "sendTitle": "傳送範本訊息",
        "sendBody": "標準請求 — 與系統內介面一致，只是改用 bearer token。"
      },
      "activity": {
        "title": "最近 API 請求",
        "subtitle": "由請求日誌讀取 · 保留 7 日",
        "loading": "載入請求日誌中…",
        "loadingMore": "載入更多…",
        "loadMore": "載入更多",
        "empty": "尚未有 API 請求紀錄。當此客戶端首次發起請求後，會顯示在此處。",
        "columns": {
          "time": "時間",
          "method": "Method",
          "path": "路徑",
          "status": "狀態",
          "latency": "延遲"
        }
      },
      "settings": {
        "editable": "可編輯",
        "ipAllowlist": "IP 白名單",
        "anyIp": "任何 IP",
        "restrict": "限制",
        "lockedFields": "鎖定欄位",
        "lockedHint": "如需放寬權限，請建立新客戶端",
        "tenantsCount_one": "{{count}} 個 workspace",
        "tenantsCount_other": "{{count}} 個 workspace",
        "scopesCount_one": "{{count}} 個 scope",
        "scopesCount_other": "{{count}} 個 scope",
        "dangerZone": "危險操作",
        "rotateTitle": "輪換客戶端密鑰",
        "rotateBody": "產生新密鑰，舊密鑰即時停用。",
        "rotate": "輪換",
        "rotateComingSoon": "即將推出",
        "revokeBody": "所有有效 token 立即失效，無法復原。",
        "discard": "捨棄",
        "save": "儲存變更",
        "saving": "儲存中…"
      }
    },
    "confirmRevoke": {
      "title": "確認撤銷此客戶端？",
      "body": "「<strong>{{name}}</strong>」的所有有效 access token 將立即失效。任何使用中的整合在發出新憑證前都無法存取系統。",
      "typeToConfirm": "輸入 <strong>{{name}}</strong> 以確認",
      "cancel": "取消",
      "confirm": "撤銷客戶端"
    },
    "confirmRotate": {
      "title": "確認輪換客戶端密鑰？",
      "body": "為「<strong>{{name}}</strong>」產生新密鑰會立即令所有由舊密鑰發出的 access token 失效。使用中的整合必須切換至新密鑰才能繼續運作。",
      "typeToConfirm": "輸入 <strong>{{name}}</strong> 以確認",
      "cancel": "取消",
      "confirm": "輪換密鑰"
    }
  },
  "developer": {
    "badge": "開發者 · API 平台",
    "title": "開發者平台",
    "lede": "為當前 workspace 發出 API 憑證，並查閱第三方 API 文件。",
    "tabs": {
      "clients": "客戶端",
      "docs": "API 文件"
    }
  },
  "apiDocs": {
    "errorTitle": "無法載入 API 文件",
    "errorBody": "請在後端執行 `php artisan scribe:generate` 產生 OpenAPI 規格後重新整理此頁面。"
  },
  "tags": {
    "title": "聯絡人標籤",
    "subtitle": "由管理員集中管理的工作區共用標籤詞彙。所有成員都可以套用標籤；只有 Owner 與 Admin 可以更改名稱、顏色或刪除。",
    "adminBadge": "管理員 · 工作區標籤庫",
    "create": "新增標籤",
    "edit": "編輯標籤",
    "delete": "刪除標籤",
    "searchPlaceholder": "依名稱搜尋標籤…",
    "noMatches": "找不到符合 \"{{term}}\" 的標籤",
    "categoryCount_one": "{{count}} 個標籤",
    "categoryCount_other": "{{count}} 個標籤",
    "card": {
      "unused": "未使用",
      "contactsCount_one": "位聯絡人",
      "contactsCount_other": "位聯絡人"
    },
    "empty": {
      "title": "建立共用的標籤詞彙",
      "body": "標籤讓團隊以相同方式分類聯絡人。常用起點：客戶等級（VIP、潛在客戶、已成交）、狀態（需跟進、緊急）、地區（香港、台北）。",
      "cta": "建立首個標籤"
    },
    "stats": {
      "inLibrary": "標籤庫總數",
      "active": "使用中標籤",
      "unused": "{{count}} 個未使用",
      "categories": "分類"
    },
    "filters": {
      "label": "依標籤篩選",
      "addAction": "新增標籤篩選",
      "addMore": "新增",
      "clearAction": "清除",
      "intersectionHint": "顯示符合所有標籤的結果",
      "allCategories": "全部"
    },
    "picker": {
      "applyTitle": "套用標籤",
      "filterTitle": "依標籤篩選",
      "applyBlurb": "套用至 {{name}} 的標籤，所有工作區成員皆可看見。",
      "filterBlurb": "結果僅顯示同時擁有所有選中標籤的聯絡人（交集）。",
      "searchPlaceholder": "搜尋標籤…",
      "noMatches": "找不到符合 \"{{term}}\" 的標籤",
      "submitApply": "儲存標籤",
      "submitFilter": "套用篩選",
      "noneSelected": "未選擇任何標籤",
      "selectedCount_one": "已選 {{count}} 個標籤",
      "selectedCount_other": "已選 {{count}} 個標籤",
      "clearSelected_one": "清除 ({{count}})",
      "clearSelected_other": "清除 ({{count}})"
    },
    "editor": {
      "preview": "預覽",
      "namePlaceholder": "標籤名稱",
      "nameLabel": "名稱",
      "nameHint": "{{n}}/64 字元",
      "colorLabel": "顏色",
      "colorHint": "用於列表及篩選器中的標籤顯示",
      "categoryLabel": "分類",
      "categoryHint": "選擇器會依分類群組顯示標籤",
      "categoryNamePlaceholder": "分類名稱",
      "newCategory": "新分類",
      "pickExisting": "選擇現有分類",
      "createBlurb": "標籤對工作區所有成員可見。",
      "editBlurb_one": "變更會立即套用至使用此標籤的 {{count}} 位聯絡人。",
      "editBlurb_other": "變更會立即套用至使用此標籤的 {{count}} 位聯絡人。",
      "editImpact_one": "重新命名或更換顏色會即時套用至 {{count}} 位已使用此標籤的聯絡人。",
      "editImpact_other": "重新命名或更換顏色會即時套用至 {{count}} 位已使用此標籤的聯絡人。",
      "saveChanges": "儲存變更"
    },
    "deleteDialog": {
      "title": "刪除此標籤？",
      "impact_one": "將從 {{count}} 位聯絡人移除。其他標籤不受影響。此動作無法復原。",
      "impact_other": "將從 {{count}} 位聯絡人移除。其他標籤不受影響。此動作無法復原。",
      "typePrompt": "請輸入"
    },
    "errors": {
      "saveFailed": "無法儲存標籤，請重試。",
      "deleteFailed": "無法刪除標籤，請重試。"
    },
    "contacts": {
      "columnHeader": "標籤",
      "noTags": "無標籤",
      "addAction": "新增標籤",
      "editAction": "編輯標籤"
    }
  }
}
